import { ReactNode, FC, useEffect } from 'react';
import { useGA } from './useGA';
import { useRUM } from './useRUM';
import { useAuth } from '../../features/auth/providers/AuthProvider';

type AnalyticsProviderProps = {
  children: ReactNode;
};

const AnalyticsProvider: FC<AnalyticsProviderProps> = ({ children }) => {
  const { userId } = useAuth();
  const { initialize: initializeRUM, setUser: setRUMUser } = useRUM();
  const { initialize: initializeGA, setUser: setGAUser } = useGA();

  useEffect(() => {
    initializeRUM();
    initializeGA();
  }, [initializeRUM, initializeGA]);

  useEffect(() => {
    if (userId) {
      setRUMUser(userId);
      setGAUser(userId);
    }
  }, [userId, setRUMUser, setGAUser]);

  return <>{children}</>;
};

export default AnalyticsProvider;
